import { Outlet } from 'react-router-dom'
import { Container, useMediaQuery, Theme, Box } from '@mui/material'
import { CompanyContextProvider } from '@/context/companies'
import { MobileNavigation } from './mobile-navigation'
import { DesktopNavigation } from './desktop-navigation'
import { usePlatform } from '@/hooks'

export function DashboardLayout() {
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'))
  const { isAndroid } = usePlatform()

  return (
    <CompanyContextProvider>
      <Box
        display="flex"
        overflow="hidden"
        height="100%"
        pb={isAndroid ? 14 : isMobile ? 12 : 2}
      >
        {isMobile ? <MobileNavigation /> : <DesktopNavigation />}

        <Container
          component="main"
          maxWidth="md"
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            pt: isAndroid ? 14 : isMobile ? 10 : 0,
            overflow: 'auto',
            position: 'relative',
          }}
        >
          <Outlet />
        </Container>
      </Box>
    </CompanyContextProvider>
  )
}
